import config from "config";
import configService from "services/configService";

function getOAuthKey() {
    const { appVersion, envName } = config;
    return appVersion === "dev" ? `pc_auth-localhost-${envName}` : "pc_auth";
}

/**
 * Get the pcAuthToken from local storage
 */
export function getPcAuthToken(): void {
    const oAuthKey = getOAuthKey();

    if (!localStorage[oAuthKey]) {
        throw new Error(
            `Failed to retrieve auth data from localStorage: ${oAuthKey}`
        );
    }

    return JSON.parse(localStorage[oAuthKey]);
}

/**
 * Set the local storage pcAuthToken from the config service. The config service will get the token from query params.
 */
export function setPcAuthToken(): void {
    const authToken = configService.authToken();
    if (authToken) {
        const oAuthKey = getOAuthKey();
        localStorage.setItem(oAuthKey, authToken);
    }
}
